import React, { useContext } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { FiArrowRight, FiCheckCircle } from "react-icons/fi";

export default function OneProduct({ data, isMinimal = false }) {
  const appContext = useContext(AppContext);

  function viewDetails() {
    appContext.navTo({
      item: "view",
      subItem: "product",
      extraItem: data.uuid,
    });
  }

  // Resolve dynamic CDN image or local path fallback

  const title = data.title;
  const description = data.description;
  const features = Array.isArray(data?.features) ? data.features : [];

  // --- MINIMAL CARD VIEW (Used in All Products Grid) ---
  if (isMinimal) {
    return (
      <div className="minimal-card reveal-item">
          <img src={CDN_URL + data.coverPhoto} className="minimal-img" alt={title} />
        <h3 className="minimal-name">{title}</h3>
        <p className="minimal-desc">{description}</p>
        <a onClick={viewDetails} className="minimal-cta">
          View Details <FiArrowRight />
        </a>
      </div>
    );
  }

  // --- FEATURE MODE VIEW (Used in Main/Homepage Layout) ---
  return (
    <div className="p-item reveal-item">
      <div className="p-img-wrapper">
        {<img src={CDN_URL + data.coverPhoto} alt={title} loading="lazy" />}
      </div>
      <div className="p-text-box">
        <h3 className="p-prod-name">{title}</h3>
        <p className="p-prod-desc">{description}</p>

        <a onClick={viewDetails} className="btn p-cta-btn">
          See How It Works <FiArrowRight size={18} />
        </a>
      </div>
    </div>
  );
}